/** @jsxImportSource react */
import { Box, Typography } from '@mui/material'

const PageHeader = ({ title, subtitle, actions, children }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: { xs: 'flex-start', sm: 'center' },
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
      mb: 3,
    }}
  >
    <Box sx={{ flexGrow: 1, minWidth: 0 }}>
      <Typography variant="h4" noWrap>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
      {children}
    </Box>
    {actions && <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
  </Box>
)

export default PageHeader
